
var space = require('to-space-case')

/**
 * Export.
 */

module.exports = toDotCase

/**
 * Convert a `string` to slug case.
 *
 * @param {String} string
 * @return {String}
 */

function toDotCase(string) {
  return space(string).replace(/\s/g, '.')
}



//////////////////
// WEBPACK FOOTER
// ../~/to-dot-case/index.js
// module id = 3048
// module chunks = 0